import {
  ApplicationConfig,
  ErrorHandler,
  isDevMode,
  provideZoneChangeDetection
} from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router'
import { provideServiceWorker } from '@angular/service-worker'

import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { provideMarkdown } from 'ngx-markdown'

import { provideLocalePin } from '@yoshu-lib/core/config/locale-pin.service'
import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideTranslate } from '@yoshu-lib/core/config/translate.provider'
import { provideKatexMathExtension } from '@yoshu-lib/core/markdown/katex-math.extension'
import { DEFAULT_THEME } from '@yoshu-lib/core/theme/theme.service'

import {
  DOCUMENT_DETAIL_LABEL_I18N_PREFIX,
  ENTITY_DETAIL_SHOW_LIST_BREADCRUMB
} from '@yoshu-lib/features/admin/pages/entities/entity-detail/entity-detail.token'

import { provideMarkdownCustomRenderer } from '@coty/core/config/marked-options.provider'

import { routes } from './app.routes'
import { GlobalErrorHandler } from './core/config/global-error-handler'
import { provideCore } from './core/core.providers'
import { provideCotyHttp } from './core/http/http.provider'
import { SiteLocaleService } from './core/site-locale.service'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideCotyHttp(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideMarkdown(),
    provideKatexMathExtension(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideCharts(withDefaultRegisterables()),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

    ...provideCore(),

    // A Coty site runs in one language whoever is logged in: the UI follows
    // site.data.locale, not the account's.
    provideLocalePin(SiteLocaleService),

    { provide: ENTITY_DETAIL_SHOW_LIST_BREADCRUMB, useValue: true },

    // OPL and Standard extractions are named in the processor's language, so a
    // Chartres document came back with Spanish field labels over French
    // content. Resolve the document viewer's labels from the bundle instead,
    // which puts them in the site's language.
    { provide: DOCUMENT_DETAIL_LABEL_I18N_PREFIX, useValue: 'document_details.labels' },

    // Coty is light-first: dark mode is opt-in via the sidebar toggle.
    // Keep in sync with the boot script in index.html.
    { provide: DEFAULT_THEME, useValue: 'light' }
  ]
}
